import { Button } from '@components/ui/button';
import { cn } from '@utils/cn';
import { useTranslation } from 'react-i18next';
import { QueryErrorProps } from './types';

export const QueryError = ({ onRetry, className }: QueryErrorProps) => {
  const { t } = useTranslation('app');

  return (
    <div
      className={cn('flex flex-col items-center justify-center gap-2 p-4 text-center', className)}>
      <p className="text-sm font-bold text-neutral-800">{t('queryError.title')}</p>
      <p className="max-w-sm text-xs text-neutral-600">{t('queryError.description')}</p>
      <Button disabled={false} variant="secondary" size="sm" className="w-fit" onClick={onRetry}>
        {t('actions.tryAgain')}
      </Button>
    </div>
  );
};
